var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"btn btn-state"})
}
var staticRenderFns = []

export { render, staticRenderFns }